export enum EGalleryDisplayMode {
	thumbnails = "thumbnails",
	list = "list",
	add = "add"
}